import { KalturaEntryStatus } from 'kaltura-ngx-client';

export interface DefaultFilterList {
  label: string;
  name: string;
  items: { value: string; label: string }[];
  value?: any;
}

export interface LocalizedDefaultFilterList {
  [key: string]: DefaultFilterList[];
}

const defaultFiltersListEn: DefaultFilterList[] = [
  {
    name: 'mediaTypes',
    label: 'Media Types',
    items: [
      { value: '1', label: 'Video' },
      { value: '2', label: 'Image' },
      { value: '5', label: 'Audio' },
      { value: '201', label: 'Live Stream' },
    ],
  },
  {
    name: 'moderationStatuses',
    label: 'Moderation Statuses',
    items: [
      { value: '2', label: 'Approved' },
      { value: '5', label: 'Flagged for review' },
      { value: '3', label: 'Rejected' },
      { value: '6', label: 'Auto approved' },
      { value: '1', label: 'Pending moderation' },
    ],
  },
  // {
  //   name: 'youtubeVideo',
  //   label: 'Youtube Video',
  //   value: true,
  //   items: [],
  // },
  // {
  //   name: 'videoQuiz',
  //   label: 'Video with Quiz',
  //   value: true,
  //   items: [],
  // },
  // {
  //   name: 'videoCaptions',
  //   label: 'Video with Captions',
  //   value: true,
  //   items: [],
  // },
  // {
  //   name: 'videoNoCaptions',
  //   label: 'Video without Captions',
  //   value: true,
  //   items: [],
  // },
  {
    name: 'ingestionStatuses',
    label: 'Ingestion Statuses',
    items: [
      { value: KalturaEntryStatus.ready.toString(), label: 'Ready' },
      { value: KalturaEntryStatus.noContent.toString(), label: 'No Media' },
      { value: KalturaEntryStatus.pending.toString(), label: 'Pending' },
      { value: KalturaEntryStatus.import.toString(), label: 'Uploading' },
      { value: KalturaEntryStatus.preconvert.toString(), label: 'Transcoding' },
      {
        value: [KalturaEntryStatus.errorConverting.toString(), KalturaEntryStatus.errorImporting.toString()].join(','),
        label: 'Error',
      },
    ],
  },
  {
    name: 'durations',
    label: 'Durations',
    items: [
      { value: 'short', label: 'Short (0-4 min.)' },
      { value: 'medium', label: 'Medium (4-20 min.)' },
      { value: 'long', label: 'Long (20+ min.)' },
    ],
  },
  // {
  //   name: 'originalClippedEntries',
  //   label: 'Original & Clipped Entries',
  //   items: [
  //     { value: '1', label: 'Original Entries' },
  //     { value: '0', label: 'Clipped Entries' },
  //   ],
  // },
  // {
  //   name: 'timeScheduling',
  //   label: 'Time Scheduling',
  //   items: [
  //     { value: 'past', label: 'Past Scheduling' },
  //     { value: 'live', label: 'Live' },
  //     { value: 'future', label: 'Future Scheduling' },
  //     { value: 'scheduled', label: 'Scheduled' },
  //   ],
  // },
  {
    name: 'replacementStatuses',
    label: 'Replacement Statuses',
    items: [
      { value: '3,1', label: 'Processing new files' },
      { value: '2', label: 'Ready for review' },
    ],
  },
];

const defaultFiltersListRu: DefaultFilterList[] = [
  {
    name: 'mediaTypes',
    label: 'Тип медиа',
    items: [
      { value: '1', label: 'Видео' },
      { value: '2', label: 'Изображение' },
      { value: '5', label: 'Аудио' },
      { value: '201', label: 'Трансляция' },
    ],
  },
  {
    name: 'moderationStatuses',
    label: 'Статус модерации',
    items: [
      { value: '2', label: 'Одобрено' },
      { value: '5', label: 'Рассмотрение жалобы' },
      { value: '3', label: 'Отклонено' },
      { value: '6', label: 'Одобрено автоматически' },
      { value: '1', label: 'Ожидается модерация' },
    ],
  },
  // {
  //   name: 'youtubeVideo',
  //   label: 'Youtube видео',
  //   value: true,
  //   items: [],
  // },
  // {
  //   name: 'videoQuiz',
  //   label: 'Видео с вопросами',
  //   value: true,
  //   items: [],
  // },
  // {
  //   name: 'videoCaptions',
  //   label: 'Видео с субтитрами',
  //   value: true,
  //   items: [],
  // },
  // {
  //   name: 'videoNoCaptions',
  //   label: 'Видео без субтитров',
  //   value: true,
  //   items: [],
  // },
  {
    name: 'ingestionStatuses',
    label: 'Статус обработки',
    items: [
      { value: KalturaEntryStatus.ready.toString(), label: 'Готово' },
      { value: KalturaEntryStatus.noContent.toString(), label: 'Нет медиа' },
      { value: KalturaEntryStatus.pending.toString(), label: 'Ожидает' },
      { value: KalturaEntryStatus.import.toString(), label: 'Загрузка' },
      { value: KalturaEntryStatus.preconvert.toString(), label: 'Транскодирование' },
      {
        value: [KalturaEntryStatus.errorConverting.toString(), KalturaEntryStatus.errorImporting.toString()].join(','),
        label: 'Ошибка',
      },
    ],
  },
  {
    name: 'durations',
    label: 'Длительность',
    items: [
      { value: 'short', label: 'Короткие (0-4 мин.)' },
      { value: 'medium', label: 'Средние (4-20 мин.)' },
      { value: 'long', label: 'Длинные (20+ мин.)' },
    ],
  },
  // {
  //   name: 'originalClippedEntries',
  //   label: 'Записи и фрагменты',
  //   items: [
  //     { value: '1', label: 'Полные записи' },
  //     { value: '0', label: 'Фрагменты' },
  //   ],
  // },
  // {
  //   name: 'timeScheduling',
  //   label: 'Расписание',
  //   items: [
  //     { value: 'past', label: 'Закончилось' },
  //     { value: 'live', label: 'В эфире' },
  //     { value: 'future', label: 'Запланировано' },
  //     { value: 'scheduled', label: 'Ожидается' },
  //   ],
  // },
  {
    name: 'replacementStatuses',
    label: 'Статус замены',
    items: [
      { value: '3,1', label: 'Обработка новых файлов' },
      { value: '2', label: 'Готово к проверке' },
    ],
  },
];

export const DefaultFiltersList: LocalizedDefaultFilterList = {
  en: defaultFiltersListEn,
  ru: defaultFiltersListRu,
};
